import CreativeSetTable from './CreativeSetTable';
import Filters from './Filters';

const Main = (): React.ReactElement => {
  return (
    <>
      <Filters />
      <CreativeSetTable />
    </>
  );
};

export default Main;
